import type { AddIncident, UpdateIncident } from '../incidents/index.js'
import type { QueueIncident } from '../types.js'

export function isAddIncident(
  queueIncident: QueueIncident,
): queueIncident is AddIncident {
  return queueIncident.type === 'Add'
}

export function isUpdateIncident(
  queueIncident: QueueIncident,
): queueIncident is UpdateIncident {
  return queueIncident.type === 'Update'
}

/**
 * Get the UUID of a queue incident.
 *
 * @param queueIncident The queue incident to get the UUID from.
 * @returns The UUID of the queue incident, or undefined if it doesn't have one.
 */
export function getQueueIncidentUuid(
  queueIncident: QueueIncident,
): string | undefined {
  if (
    queueIncident.type === 'Add' ||
    queueIncident.type === 'Update' ||
    queueIncident.type === 'Delete'
  ) {
    return queueIncident.uuid
  }

  return undefined
}
